// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ShopOrderBatchPrintApi {
	export async function printShopOrderBatchLabels(args: {
		shopOrderBatchIds: Array<number>;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/printShopOrderBatchLabels",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printShopOrderBatchWorkOrder(args: {
		shopOrderBatchId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/printShopOrderBatchWorkOrder",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printSawList(args: { shopOrderBatchId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/printSawList",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}
}
